import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useUserData } from '../hooks';
import styles from './UserProfileDropdown.module.css';

const UserProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { userData, loading } = useUserData();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (loading) {
    return (
      <div className={styles.userProfileDropdown}>
        <div className={styles.welcomeText}>Loading...</div>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className={styles.userProfileDropdown}>
        <div className={styles.welcomeText}>Welcome!</div>
      </div>
    );
  }

  const displayName = userData.displayName || userData.firstName || 'User';
  const firstName = userData.firstName || 'User';
  const isAdmin = userData.role === 'admin_user';

  const monthlyCredits = userData.monthlyCredits || (isAdmin ? 0 : 25);
  const creditsUsed = userData.creditsUsed || 0;
  const remainingCredits = monthlyCredits - creditsUsed;

  return (
    <div className={styles.userProfileDropdown} ref={dropdownRef}>
      <div
        className={styles.welcomeText}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{firstName}{isAdmin && ' (Admin)'}</span>
        {!isAdmin && <span className={styles.creditCounter}>{remainingCredits}/{monthlyCredits} credits</span>}
        <span className={styles.dropdownArrow}>▼</span>
      </div>

      {isOpen && (
        <div className={styles.dropdownMenu}>
          <button
            className={`${styles.dropdownItem} ${styles.signoutBtn}`}
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfileDropdown;
